// BrimLight/client/ui/UserDashboard.js
import { ComponentBase } from "../core/ComponentBase.js";

export class UserDashboard extends ComponentBase {
    constructor(config) {
        super(config);
        this.dashboardComponent = null;
    }

    async initialize() {
        // Initialize the generic Dashboard with customizations disabled
        // to enforce the standard BrimLight layout.
        this.dashboardComponent = await this.createManagedComponent('Dashboard', null, {
            instanceId: `${this.config.instanceId}-user-dashboard`,
            disableCustomizations: true, 
            resizableWidgets: true, 
        });
        await super.initialize();
    }
    
    async initAfterLogin() {
        if(this.dashboardComponent){
            const predefinedLayout = [
                // Row 1: Quick Actions (Left) and Asset Stats (Right)
                { name: 'QuickActionsWidget', widgetId: 'blQuickActions', rows: 8, cols: 10 },
                { name: 'AssetLibraryStatsWidget', widgetId: 'blAssetStats', rows: 8, cols: 20 },
                
                // Row 2: Recent Projects (Main focus) and Status Chart (Side)
                { name: 'RecentProjectsWidget', widgetId: 'blRecentProjects', rows: 14, cols: 20 },
                { name: 'ProjectStatusChartWidget', widgetId: 'blProjectStatus', rows: 14, cols: 10 },

                // Row 3: Render Jobs and Series Gallery
                { name: 'RecentRenderJobsWidget', widgetId: 'blRecentRenders', rows: 12, cols: 15 },
                { name: 'SeriesGalleryWidget', widgetId: 'blSeriesGallery', rows: 12, cols: 15 },
            ];
            
            await this.dashboardComponent.setDashboardLayout(predefinedLayout);
        }
    }

    async render() {
        // The container is already set up in initialize, so render just returns it.
        return this.dashboardComponent.render();
    }
}